<template>
  <a :href="href" @click.prevent="handleDropdownResultClick">
    <div class="searchbar-dropdown-item-content">
      <div class="xusericon" data-size="small">
        <div class="xusericon-picture">
          {{ result?.borrowerInitials }}
        </div>
      </div>
      <div class="header-search-dropdown-result">
        <h4>{{ result.borrowerName || "No Name" }}</h4>
        <h5 :title="result.lenderName">
          {{ result.lenderName }}
        </h5>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { computed } from "vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";

interface Props {
  pageName: string;
  result: CertificationSearchResultModel | DisbursementSearchResultModel;
}

const props = withDefaults(defineProps<Props>(), {
  pageName: "",
});

const href = computed<string>(() => getResultUrl(props.result));

const searchPageStore = useSearchPageStore();

function handleDropdownResultClick() {
  searchPageStore.handleSearchResultClick(props.result, props.pageName);
}

function getResultUrl(
  result: CertificationSearchResultModel | DisbursementSearchResultModel
) {
  const page = props.pageName;
  const id = searchPageStore.getRouteIdentifier(page, result);
  return `/${page}/${id}`;
}
</script>

<style scoped>
.header-search-dropdown-result {
  flex: 1;
  min-width: 0;
  vertical-align: middle;
}

div.searchbar-dropdown-item-content {
  background-color: #fff;
  display: flex;
  padding: 10px 15px;
  border-bottom: 1px solid #eeeeee;
  font-size: 14px;
}

.header-search-dropdown-result h4 {
  font-family: "Montserrat";
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.header-search-dropdown-result h5 {
  color: #9b9b9b;
  font-family: "Montserrat";
  font-weight: 600;
}

div.xusericon div.xusericon-picture {
  font-weight: 700;
}
</style>
